module.exports = __webpack_public_path__ + "img/clipboard.6e5a47f2.png";